"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusObservable = exports.sendStatus = void 0;
const events = {};
const subscribe = (event, callback) => {
    if (!events[event]) {
        events[event] = [];
    }
    events[event].push(callback);
};
const publish = (event, data) => {
    if (events[event]) {
        events[event].forEach((callback) => {
            callback(data);
        });
    }
};
const sendStatus = (sts) => {
    publish('statusChange', sts);
};
exports.sendStatus = sendStatus;
const statusObservable = (callback) => {
    subscribe('statusChange', callback);
};
exports.statusObservable = statusObservable;
